import axiosInstance from "../../apiAxios/axiosInstance";

export const PurchaseList = async (payload) => {
  const response = await axiosInstance.post("/admin/purchase-list", payload);
  return response.data;
};
export const ActivePurchaseList = async(payload) => {
   const resposne=await axiosInstance.post("/admin/active-purchase-list",payload);
   return resposne.data
};
export const BrandBasePurchaseList = async(payload) => {
   const resposne=await axiosInstance.post("/admin/brand-base-product-list",payload);
   return resposne.data
};
export const AddPurchase = async (payload) => {
  const response = await axiosInstance.post("/admin/purchase-store", payload);
  return response.data;
};

export const ViewPurchaseProducts = async (payload) => {
  const response = await axiosInstance.post("/admin/purchase-show", payload);
  return response.data;
};

export const UpdatePurchase = async (payload) => {
  const response = await axiosInstance.post("/admin/purchase-update", payload);
  return response.data;
};

export const DeletePurchase = async (payload) => {
  const response = await axiosInstance.post("/admin/purchase-delete", payload);
  return response.data;
};

export const PurchaseChangeStatus = async (payload) => {
  const response = await axiosInstance.post(
    "/admin/purchase-status-update",
    payload
  );
  return response.data;
};